import { render } from "./homeIndex.vue?vue&type=template&id=dae3715a&scoped=true"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"

import "./homeIndex.vue?vue&type=style&index=0&id=dae3715a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae3715a"]])

export default __exports__